import { setInitialPageviewFiredState } from './gtmStatus.ts';
import { setGtmEventQueue } from './gtmEventQueue.ts';

import { resetGtmTrackingInSamePageView } from './trackingStatus.ts';

const resetGTMPageView = (): void => {
    setInitialPageviewFiredState(false);
    setGtmEventQueue([]);
};

/**
 * resets the google tag manager tracking by setting all the flags back to false, recreating the event queue
 * ** FOR TESTING **
 */
export function resetGtmTracking(): void {
    resetGtmTrackingInSamePageView();
    resetGTMPageView();
}
